import './ReportGenerator.css';

import React, { useRef, useState } from "react";

import { useMsal } from "@azure/msal-react";
import { generateReport } from 'src/api/backendApi';
import { FileUpload, FileUploadFilesEvent } from 'primereact/fileupload';
import { ToastSeverity, useToastContext } from 'src/toastProvider';
import { ProgressSpinner } from 'primereact/progressspinner';


export const ReportGenerator = ({ path, title }: {path: string, title: string}) => {

  const fileRef = useRef<FileUpload>(null);
  const { instance } = useMsal();
  const { showToast } = useToastContext();
  const [isGenerating, setGenerating] = useState(false);

  const uploadFiles = (event: FileUploadFilesEvent) => {
    setGenerating(true);
    generateReport(event.files, path, instance).then((result) => {
      showToast('Rapport succesvol gegenereerd', ToastSeverity.SUCCESS);
      if (fileRef.current) {
        fileRef.current.clear();
      }
    }).catch((err) => {
        showToast('Genereren rapport mislukt: ' + err.message, ToastSeverity.ERROR);
    }).finally(() => {
      setGenerating(false);
    });
  }

  return (
    <div className='main flex flex-column align-items-center'>
      <h1>{title}</h1>
      <p>Selecteer één of meerdere bestanden en genereer vervolgens een rapport.</p>
      <FileUpload
        ref={fileRef}
        id="upload"
        name="file"
        accept=".json"
        mode="advanced"
        multiple={true}
        customUpload
        auto={false}
        uploadHandler={uploadFiles}
        chooseLabel={"Selecteer Bestand(en)"}
        uploadLabel='Genereer Rapport'
        disabled={isGenerating}
      />
      {isGenerating && (
        <div className="overlay">
          <ProgressSpinner/>
        </div>
      )}
    </div>
  )
}